import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

const NavigationIndicators = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="fixed left-4 top-1/2 transform -translate-y-1/2 z-50 flex flex-col space-y-3">
      {/* Up Arrow */}
      <button
        onClick={scrollToTop}
        className="group bg-white/90 backdrop-blur-md hover:bg-violet-500 text-violet-600 hover:text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-violet-200"
        title="Go to Top"
      >
        <ChevronUp size={20} />
        <div className="absolute left-full ml-3 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          Go to Top
        </div>
      </button>

      {/* Down Arrow */}
      <button
        onClick={scrollToBottom}
        className="group bg-white/90 backdrop-blur-md hover:bg-violet-500 text-violet-600 hover:text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-violet-200"
        title="Go to Footer"
      >
        <ChevronDown size={20} />
        <div className="absolute left-full ml-3 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          Go to Footer
        </div>
      </button>
    </div>
  );
};

export default NavigationIndicators;